import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CaregiverFamilyRatingSummary } from '../../models/caregiver-family-rating.model';

@Injectable({
  providedIn: 'root'
})
export class FamilyRatingService {
  private baseURL = `${environment.baseURL}/caregiver-family-rating`;

  constructor(private http: HttpClient) { }

  /** Tutti i rating delle famiglie per il caregiver, con medie e conteggio (solo ADMIN / FAMILYTUTOR). */
  getAllRatings(docRef: string): Observable<CaregiverFamilyRatingSummary> {
    return this.http.get<CaregiverFamilyRatingSummary>(`${this.baseURL}/${docRef}/all`);
  }
}
